import { createFileRoute } from '@tanstack/react-router';
import { PurchaseOrderRegister } from '../../../features/purchasing-intake/PurchaseOrderRegister';

/** Owned by G20. PO register + create/edit (DRAFT), send, cancel. */
export const Route = createFileRoute('/_authenticated/purchasing-intake/purchase-orders')({
  component: PurchaseOrderRegister,
});
